import useApiQuery from 'shared/hooks/use-api-query';
import {SegmentProps} from '../types';

const useSegmentsSelect = () => {
  const {data = [], ...rest} = useApiQuery({
    url: '/segments/all',
  });

  return {
    ...rest,
    data: data?.map((segment: SegmentProps) => ({
      label: segment.name,
      value: segment.id,
    })),
  };
};

export default useSegmentsSelect;
